import * as tslib_1 from "tslib";
import { listApi } from "../../../../api";
import { Tabs } from "@h3/antd-vue";
import { Component, Prop, Provide } from "vue-property-decorator";
import { FormRenderer } from "./form-renderer";
import FormGroup from "./layout/form-group.vue";
import FormTabs from "./layout/pc-form-tabs.vue";
import ControlAdapter from "./pc/control-adapter.vue";
import FormCol from "./pc/form-col.vue";
import FormRow from "./pc/form-row.vue";
let PcFormRenderer = class PcFormRenderer extends FormRenderer {
    getSourceType() {
        return this.sourceType;
    }
    getController() {
        return this.controller;
    }
    findController(key, rowIndex) {
        if (!this.controller) {
            return;
        }
        // @ts-ignore
        return this.controller.findChild(key, rowIndex);
    }
    getFormControls(keys) {
        return super.findFormControls(keys);
    }
    emitSheetColumnResize(data) {
        this.$emit("sheetColumnResize", data);
    }
    valChange(keys, fun) {
        if (this && this.controller) {
            const _ctrl = this.controller.findChild(keys);
            // if (!_ctrl) return;
            _ctrl.valueChange.subscribe((change) => {
                fun(change);
            });
        }
    }
    getDataItem(keys, parentKey) {
        if (parentKey) {
            const sheet = this.dataItems.find(res => {
                return res.code === parentKey;
            });
            if (sheet && sheet.subSchema) {
                return sheet.subSchema.properties.find(res => res.code === keys);
            }
        }
        else {
            return this.dataItems.find(res => res.code === keys);
        }
    }
    getFormPermission() {
        return this.formPermission;
    }
    getRelativeDataList(isList) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.relevanceDataList || !this.relevanceDataList.length) {
                let { schemaCode } = this.$route.params;
                if (!schemaCode) {
                    schemaCode = this.$route.params.bizSchemaCode;
                }
                if (!schemaCode) {
                    schemaCode = this.$route.query.schemaCode;
                }
                if (!schemaCode) {
                    schemaCode = this.schemaCode;
                }
                if (isList && this.schemaCode) {
                    schemaCode = this.schemaCode;
                }
                if (!schemaCode) {
                    return;
                }
                const res = yield listApi.getDataItemList({
                    schemaCode
                });
                const { errcode, errmsg, data } = res;
                if (errcode === 0) {
                    return data;
                }
                else {
                    this.$message.error(errmsg);
                }
            }
            return this.relevanceDataList;
        });
    }
    render(h) {
        return super.render(h, false);
    }
};
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "relevanceDataList", void 0);
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "sourceType", void 0);
tslib_1.__decorate([
    Prop()
], PcFormRenderer.prototype, "schemaCode", void 0);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getSourceType", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getController", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "findController", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getFormControls", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "emitSheetColumnResize", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "valChange", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getDataItem", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getFormPermission", null);
tslib_1.__decorate([
    Provide()
], PcFormRenderer.prototype, "getRelativeDataList", null);
PcFormRenderer = tslib_1.__decorate([
    Component({
        name: "pc-form-renderer",
        components: {
            ControlAdapter,
            FormCol,
            FormRow,
            FormGroup,
            FormTabs,
            // FormTabsPane,
            ATabPane: Tabs.TabPane
        }
    })
], PcFormRenderer);
export default PcFormRenderer;
